import React, { memo } from 'react';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import allItemsOutOfStock from 'utilities/sku/isAllOptionsOutOfStock';
import { StockCode } from 'types/ProductResponseType';

const getStockMessageColour = (code: StockCode): string => {
  switch (code) {
    case StockCode.OUTOFSTOCK:
    case StockCode.UNAVAILABLE:
      return 'var(--color-universal-redMid)';
    case StockCode.DCSTOCK:
    case StockCode.DDSTOCK:
    case StockCode.DDSTOCKWORKINGDAYS:
    case StockCode.DDSTOCKWEEK:
    case StockCode.DDSTOCKDATE:
    case StockCode.DDSTOCKNEXTDATE:
      return 'var(--color-universal-greenMid)';
    default:
      return 'var(--color-universal-bronzeMid)';
  }
};

const StockMessageDisplay = memo(() => {
  const { selectedSku, skus } = useSelectedSkuContext();
  const isEachItemOutOfStock = allItemsOutOfStock(skus);

  if (isEachItemOutOfStock) {
    return (
      <div data-testid="stock-message">
        <TypographyElement tag="p" size="1" color={getStockMessageColour(StockCode.OUTOFSTOCK)}>
          {skus[0]?.stock?.primary}
        </TypographyElement>
        <p>{skus[0]?.stock?.secondary}</p>
      </div>
    );
  }

  if (selectedSku?.stock && selectedSku?.stock?.code) {
    return (
      <div data-testid="stock-message">
        <TypographyElement tag="p" size="1" color={getStockMessageColour(selectedSku.stock.code)}>
          {selectedSku?.stock?.primary}
        </TypographyElement>
        <p>{selectedSku?.stock?.secondary}</p>
      </div>
    );
  }

  return null;
});

export default StockMessageDisplay;
